import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { BrowserWindow, Experiments, IAppDidMountHandler, IAppWillUnmountHandler } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol, ExperimentsSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'
import { freezeSpxUnitDuringResize } from './spxResizeSettle'
import { name } from './symbols'
import type { AccessibilityBrowserZoomSiteConfig } from './types'

const spxResizeSettleSiteFactory = (
	window: BrowserWindow,
	experiments: Experiments,
	siteConfig: AccessibilityBrowserZoomSiteConfig
): IAppDidMountHandler & IAppWillUnmountHandler => {
	let stopFreezing: (() => void) | null = null

	return {
		appDidMount() {
			if (window && siteConfig.isResponsive && isExperimentOpen(experiments, 'spxResizeSettle')) {
				stopFreezing = freezeSpxUnitDuringResize(window)
			}
		},
		appWillUnmount() {
			stopFreezing?.()
			stopFreezing = null
		},
	}
}

export const SpxResizeSettleSite = withDependencies(
	[BrowserWindowSymbol, ExperimentsSymbol, named(SiteFeatureConfigSymbol, name)] as const,
	spxResizeSettleSiteFactory
)
